
import { Options, Vue } from 'vue-class-component'
import theNewsArchive from '@/components/Frontend/NewsArchive/index.vue'

@Options({
  components: {
    theNewsArchive
  }
})
export default class NewsArchiveView extends Vue {}
